import * as React from 'react';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import { useIntl } from '@grandvisionhq/state';
import { parseHtml } from '@grandvisionhq/utils';

const CountdownSection = ({ name , value , hasColon  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "cdt__time-section"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "cdt__time-section__number",
        "data-t": `cdt-number-${name}`
    }, formatTime(value)), /*#__PURE__*/ React.createElement("span", {
        className: "cdt__time-section__label",
        "data-t": `cdt-time-section-label-${name}`
    }, getLabel(`common.countdown.unit.${name}`))), hasColon && /*#__PURE__*/ React.createElement("span", {
        className: "cdt__time-section__colon"
    }, ":"));
};
const calculateTimeLeft = (endDate)=>{
    const total = new Date(endDate).getTime() - new Date().getTime();
    const seconds = Math.floor(total / 1000 % 60);
    const minutes = Math.floor(total / 1000 / 60 % 60);
    const hours = Math.floor(total / (1000 * 60 * 60) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    return {
        end: total <= 0,
        days: Math.max(0, days),
        hours: Math.max(0, hours),
        minutes: Math.max(0, minutes),
        seconds: Math.max(0, seconds)
    };
};
const formatTime = (time)=>String(time).padStart(2, '0')
;
const CountdownTimer = ({ endDate , countdownText , showCountdown , url , layout ,  })=>{
    const isClient = useIsClient();
    const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft(endDate));
    React.useEffect(()=>{
        const timer = setInterval(()=>{
            const { hours , days , minutes , seconds , end  } = calculateTimeLeft(endDate);
            if (end) {
                clearInterval(timer);
            }
            setTimeLeft({
                hours,
                days,
                minutes,
                seconds,
                end
            });
        }, 1000);
        return ()=>clearInterval(timer)
        ;
    }, [
        endDate
    ]);
    if (!(isClient && showCountdown && timeLeft)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("a", {
        href: url,
        className: "cdt",
        "data-t": "cdt"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cdt__content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: `cdt__text-container cdt__text-container-${layout}`
    }, parseHtml(countdownText.value)), /*#__PURE__*/ React.createElement("div", {
        className: "cdt__timer-container"
    }, /*#__PURE__*/ React.createElement(CountdownSection, {
        name: "days",
        value: timeLeft.days,
        hasColon: true
    }), /*#__PURE__*/ React.createElement(CountdownSection, {
        name: "hours",
        value: timeLeft.hours,
        hasColon: true
    }), /*#__PURE__*/ React.createElement(CountdownSection, {
        name: "minutes",
        value: timeLeft.minutes,
        hasColon: true
    }), /*#__PURE__*/ React.createElement(CountdownSection, {
        name: "seconds",
        value: timeLeft.seconds
    }))));
};
var CountdownTimer$1 = CountdownTimer;

export { CountdownTimer$1 as default };
//# sourceMappingURL=CountdownTimer.js.map
